module.exports = __webpack_public_path__ + "images/feature/20160901_04-970ea5b08fa7a0db8334cacad0189c10.png";